"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TokenList_1 = __importDefault(require("./TokenList"));
const Market_1 = __importDefault(require("./bifi/Market"));
const User_1 = __importDefault(require("./bifi/User"));
const SI_1 = __importDefault(require("./bifi/SI"));
const CircuitBreak_1 = __importDefault(require("./bifi/CircuitBreak"));
const BtcPublicKeyHashes_1 = __importDefault(require("./bifi/BtcPublicKeyHashes"));
const BtcInflow_1 = __importDefault(require("./bifi/BtcInflow"));
const BtcOutflow_1 = __importDefault(require("./bifi/BtcOutflow"));
const BtcChallenge_1 = __importDefault(require("./bifi/BtcChallenge"));
const BtcSubmittedUnit_1 = __importDefault(require("./bifi/BtcSubmittedUnit"));
const BtcConfirmGuarantee_1 = __importDefault(require("./bifi/BtcConfirmGuarantee"));
const BtcCurrentHeight_1 = __importDefault(require("./bifi/BtcCurrentHeight"));
const BtcFee_1 = __importDefault(require("./bifi/BtcFee"));
const BtcCalcInflowFee_1 = __importDefault(require("./bifi/BtcCalcInflowFee"));
const BtcCalcOutflowFee_1 = __importDefault(require("./bifi/BtcCalcOutflowFee"));
const OraclePeriodDelta_1 = __importDefault(require("./bifi/OraclePeriodDelta"));
const pool_1 = __importDefault(require("./srd/pool"));
const stake_1 = __importDefault(require("./srd/stake"));
const MaxBoost_1 = __importDefault(require("./x-bifi/MaxBoost"));
const StartPosition_1 = __importDefault(require("./x-bifi/StartPosition"));
const PositionNFTs_1 = __importDefault(require("./x-bifi/PositionNFTs"));
const Claim_1 = __importDefault(require("./x-bifi/Claim"));
const EndPosition_1 = __importDefault(require("./x-bifi/EndPosition"));
const LimitOfActions_1 = __importDefault(require("./x-bifi/LimitOfActions"));
const AmountsOfOut_1 = __importDefault(require("./x-bifi/AmountsOfOut"));
const Oracle_1 = __importDefault(require("./x-bifi/Oracle"));
exports.default = [
    TokenList_1.default,
    Market_1.default,
    User_1.default,
    SI_1.default,
    CircuitBreak_1.default,
    BtcPublicKeyHashes_1.default,
    BtcInflow_1.default,
    BtcOutflow_1.default,
    BtcChallenge_1.default,
    BtcSubmittedUnit_1.default,
    BtcConfirmGuarantee_1.default,
    BtcCurrentHeight_1.default,
    BtcFee_1.default,
    BtcCalcInflowFee_1.default,
    BtcCalcOutflowFee_1.default,
    OraclePeriodDelta_1.default,
    ...pool_1.default,
    ...stake_1.default,
    MaxBoost_1.default,
    StartPosition_1.default,
    PositionNFTs_1.default,
    Claim_1.default,
    EndPosition_1.default,
    LimitOfActions_1.default,
    AmountsOfOut_1.default,
    Oracle_1.default
];
//# sourceMappingURL=index.js.map